import { defineSlotRecipe } from "@chakra-ui/react";

const menuRecipe = defineSlotRecipe({
    className: "chakra-menu",
    slots: ["root", "trigger", "content", "item"],
    base: {
        root: {
            color: "ebonyClay.500",
            textDecor: "underline",
            _hover: {
                textDecor: "underline"
            },
            _disabled: {
                color: "gray.400",
                _hover: {
                    cursor: "not-allowed",
                    textDecor: "underline"
                }
            }
        },
        item: {
            cursor: "pointer"
        }
    }
});

export default menuRecipe;
